import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

// LocationDropdown Component
// A reusable dropdown for selecting a location from API data
const LocationDropdown = ({ value, onChange, className = '', name = 'location_id' }) => {
  // State to store fetched locations
  const [locations, setLocations] = useState([]);
  // State to handle loading status
  const [loading, setLoading] = useState(false);

  // Fetch locations when component mounts
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoading(true); // Start loading
        const res = await axiosInstance.get('/ems/locations'); // API call
        setLocations(res.data || []); // Save data or empty array
      } catch (err) {
        console.error('Error fetching locations:', err); // Handle error
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchLocations();
  }, []);

  return (
    <select
      name={name} // Controlled input name
      value={value} // Selected value from parent
      onChange={(e) => onChange({ target: { name, value: e.target.value } })} // Trigger parent handler
      className={`form-select ${className}`} // Bootstrap style + custom classes
      disabled={loading} // Disable dropdown while loading
    >
      {/* Default option */}
      <option value="">{loading ? 'Loading...' : 'Select Location'}</option>
      
      {/* Map through locations and create option list */}
      {locations.map(loc => (
        <option key={loc.id} value={loc.id}>{loc.location_name}</option>
      ))}
    </select>
  );
};

export default LocationDropdown;
